import {
  ChangeDetectorRef,
  DestroyRef,
  Directive,
  OnInit,
  OnDestroy,
  TemplateRef,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LayoutService } from 'src/app/shared/services/layout/layout.service';

@Directive({
  selector: '[isMobile]',
  standalone: true,
})
export class IsMobileDirective implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly templateReference = inject(TemplateRef<unknown>);
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly layoutService = inject(LayoutService);

  ngOnInit(): void {
    this.calculateView(this.layoutService.isMobile);
    this.breakpointListener();
  }

  private breakpointListener(): void {
    this.layoutService.onBreakpointChanged$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.calculateView(this.layoutService.isMobile);
        this.changeDetectorRef.markForCheck();
      });
  }

  private calculateView(match: boolean): void {
    if (match) {
      this.viewContainerRef.clear();
      this.viewContainerRef.createEmbeddedView(this.templateReference);

      return;
    }

    this.viewContainerRef.clear();
  }

  ngOnDestroy(): void {
    if (this.viewContainerRef) {
      this.viewContainerRef.clear();
      this.viewContainerRef.detach();
    }
  }
}
